import { EventEmitter } from "events";

export const GlobalEmitter = new EventEmitter();

export class SinglePurposeEmitter {
  #handlers = new Set();

  attach(callback) {
    this.#handlers.add(callback);
  }

  detach(callback) {
    this.#handlers.delete(callback);
  }

  emit(e) {
    for (const handler of this.#handlers) handler(e);
  }
}

export const getEventOptions = e => {
  let target;

  switch (e.type) {
    case "touchmove":
      target = e.touches[0];
      break;
    case "touchend":
    case "touchstart":
      target = e.changedTouches[0];
      break;
    default:
      target = e;
  }

  return target;
};

export const getClientPosition = e => {
  const target = getEventOptions(e);

  return {
    x: target.pageX,
    y: target.pageY
  };
};
